module.exports = __webpack_public_path__ + "static/img/1.510f93c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/eng/1.png
// module id = 28Re
// module chunks = 0